import { render, staticRenderFns } from "./AlarmZone.vue?vue&type=template&id=dffd6cda&scoped=true&"
import script from "./AlarmZone.vue?vue&type=script&lang=js&"
export * from "./AlarmZone.vue?vue&type=script&lang=js&"
import style0 from "./AlarmZone.vue?vue&type=style&index=0&id=dffd6cda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dffd6cda",
  null
  
)

export default component.exports